export default class AdminLabReports {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminLabReportsRoute, {
      params
    })
  }

  getChart(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabReportsRoute}/chart`, {
      params
    })
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabReportsRoute}/export`, {
      params,
      responseType: "blob"
    })
  }
}
